<div class="edit-main">
  <div class="header mt-3 mb-3">
    <div class="top-header">
      <img
        src="{{
          enableBackOperation ? '/assets/svg/ico-chevron-back-outline.svg' : ''
        }}"
        class="pointer-cursor"
        (click)="navigateBack()"
      />
      <div>
        <p class="top-heading">
          <app-with-tooltip [showHelpCursor]="true">{{
            selectedSite?.siteName
          }}</app-with-tooltip>
        </p>
        <h2 class="modal-title text-center heading2">
          <app-with-tooltip [showHelpCursor]="true"
            >{{
              (this.sharedData?.selectedBuilding?.buildingName &&
              this.sharedData?.editMode?.building
                ? this.sharedData?.selectedBuilding?.buildingName
                : "NEW_BUILDING"
              ) | translate
            }}
          </app-with-tooltip>
        </h2>
      </div>

      <div (click)="closeDialog()">
        <img
          src="/assets/svg/ico-hamburger-close.svg"
          class="close-icon pointer-cursor"
        />
      </div>
    </div>
    <br />
    <h1 class="text-center heading1">
      {{
        (this.sharedData.editMode.building ? "EDIT_DETAILS" : "ADD_DETAILS")
          | translate
      }}
    </h1>
  </div>

  <!-- Error messages -->
  <div
    class="mb-2 mx-2 alert alert-danger alert-dismissible fade show notification-alert"
    role="alert"
    *ngIf="errorMessage"
  >
    {{ errorMessage }}
    <button type="button" class="close" (click)="closeError()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form [formGroup]="formGroup" (ngSubmit)="onUpdateBuildingHandler(true)">
    <div class="form-group rounded-top form-container p-2" cdkScrollable>
      <mat-form-field appearance="fill" class="w-100 mb-2 text-height">
        <mat-label>{{ "BUILDING_NAME" | translate }}</mat-label>
        <input
          matInput
          minlength="1"
          [placeholder]="'ENTER_BUILDING_NAME' | translate"
          formControlName="name"
        />
        <mat-error *ngIf="formGroup?.controls?.name?.errors?.whitespace">{{
          "EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED" | translate
        }}</mat-error>
        <mat-error *ngIf="formGroup?.controls?.name?.errors?.required">{{
          "YOU_MUST_ENTER_BUILDING_NAME" | translate
        }}</mat-error>
        <mat-error *ngIf="formGroup?.controls?.name?.errors?.minlength">
          {{
            commonService.stringInterPolation(
              "MINIMUM_OF_CHARACTERS" | translate,
              "1"
            )
          }}
        </mat-error>
        <mat-error *ngIf="formGroup?.controls?.name?.errors?.maxlength">
          {{
            commonService.stringInterPolation(
              "MAXIMUM_OF_CHARACTERS" | translate,
              "64"
            )
          }}
        </mat-error>
        <mat-error
          *ngIf="
            formGroup?.controls?.name?.errors?.entityName &&
            !formGroup?.controls?.name?.errors?.required &&
            !formGroup?.controls?.name?.errors?.whitespace &&
            !formGroup?.controls?.name?.errors?.minlength &&
            !formGroup?.controls?.name?.errors?.maxLength
          "
          >{{ "YOU_MUST_ENTER_VALID_BUILDING_NAME" | translate }}</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-100 mb-2 text-height">
        <mat-label>{{ "ADDRESS" | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'ENTER_ADDRESS' | translate"
          formControlName="address"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option
            *ngFor="let suggestion of filteredSuggestions | async"
            [value]="suggestion"
          >
            {{ suggestion }}
          </mat-option>
        </mat-autocomplete>
        <mat-error>
          <span *ngIf="formGroup?.controls?.address?.errors?.whitespace">{{
            "EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED" | translate
          }}</span>
          <span *ngIf="formGroup?.controls?.address?.errors?.required">{{
            "YOU_MUST_ENTER_ADDRESS" | translate
          }}</span>

          <span
            *ngIf="
              formGroup?.controls?.address?.errors?.maxlength &&
              !formGroup?.controls?.address?.errors?.whitespace
            "
          >
            {{
              commonService.stringInterPolation(
                "MAXIMUM_OF_CHARACTERS" | translate,
                "255"
              )
            }}
          </span>
          <span
            *ngIf="
              formGroup?.controls?.address?.errors?.minlength &&
              !formGroup?.controls?.address?.errors?.whitespace
            "
          >
            {{
              commonService.stringInterPolation(
                "MINIMUM_OF_CHARACTERS" | translate,
                "2"
              )
            }}
          </span>
          <span
            *ngIf="
              !formGroup?.controls?.address?.errors?.required &&
              !formGroup?.controls?.address?.errors?.whitespace &&
              !formGroup?.controls?.address?.errors?.minlength &&
              !formGroup?.controls?.address?.errors?.maxlength
            "
            >{{ "YOU_MUST_ENTER_VALID_BUILDING_ADDRESS" | translate }}</span
          >
        </mat-error>
      </mat-form-field>

      <div
        class="floors-list mb-2"
        *ngFor="
          let floor of floors | sortBy : 'floorName' : 'asc';
          let i = index
        "
      >
        <app-modal-item-view
          *ngIf="floors.length !== 0"
          [imagesource]="floorimage"
          [title]="floor?.floorName"
          [description]="floor?.wingName"
          (click)="removeFloor(floor?.floorId, floor?.floorName)"
          role="button"
        >
        </app-modal-item-view>
      </div>

      <button
        type="button"
        class="add-button px-5 py-3 mt1 mb-4 w-100"
        (click)="openAddFloor()"
        [controlDisabled]="[PageName.Floor, CONSTANTS.CREATE]"
        [disabledCheck]="!formGroup.valid || this.floors?.length > 49"
      >
        <strong> {{ "ADD_FLOOR" | translate }} </strong>
      </button>
      <div
        class="row d-flex flex-row justify-content-center align-items-center"
      >
        <button
          *ngIf="this.sharedData?.editMode?.building"
          (click)="onRemoveBuilding()"
          class="d-flex flex-row justify-content-center align-items-center d-none remove-btn"
          type="button"
          [controlDisabled]="[PageName.Building, CONSTANTS.DELETE]"
        >
          <img src="assets/svg/ico-close-circle-outline.svg" />

          <p class="remove-building ml-2 pt-2">
            {{ "REMOVE_BUILDING" | translate }}
          </p>
        </button>
      </div>
    </div>

    <input
      type="file"
      id="fileUploadBuilding"
      name="fileUploadBuilding"
      accept=".jpeg,.png,.jpg"
      class="d-none"
    />

    <a
      id="building-photo-download"
      class="d-none"
      href="{{ buildingPhotoURL }}"
      target="_blank"
      rel="noopener"
      download
    ></a>

    <div class="row mt-2">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 done-btn"
          type="button"
          tabindex="0"
          (click)="onDoneHandler()"
          [controlDisabled]="[PageName.Building, CONSTANTS.CREATE]"
          [disabledCheck]="!formGroup.valid"
        >
          {{ "DONE" | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
